import React, { useEffect } from "react";
import { Alert, Button, Col, Container, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  initSrvcObj,
  NAME_REGEX,
  NUMBER_NINE_DECIMAL,
  PTRN_ERR_MSG,
  REQUIRED_ERR_MSG,
} from "../Helper/Constants";
import GetSvgIcon from "../../images/svglist";
import { CH_SRVC_TYPE } from "../../ConfigConstants/ConfigConstants";
import { numberInputOnWheelPreventChange } from "../Helper/CommonMethods";

const CharteredRateAddEdit = ({
  modalConfig,
  custList,
  rateType,
  onHide,
  selRate,
  onSubmit,
  vhclTypeOpt,
  error,
  setError,
}) => {
  const {
    register,
    reset,
    control,
    watch,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors, isDirty },
  } = useForm();

  const watchRateId = watch("rateId");
  const watchRateType = watch("rateTypeId");

  const handleClose = () => {
    onHide();
  };

  const { fields: baseChg } = useFieldArray({
    control,
    name: "baseChg",
  });
  const { fields: pieces } = useFieldArray({
    control,
    name: "pieces",
  });
  const {
    fields: vhclType,
    append: vtAppend,
    remove: vtRemove,
  } = useFieldArray({
    control,
    name: "vhclType",
  });
  const {
    fields: otherCharges,
    append: ocAppend,
    remove: ocRemove,
  } = useFieldArray({
    control,
    name: "otherCharges",
  });
  const { fields: extService } = useFieldArray({
    control,
    name: "extService",
  });

  useEffect(() => {
    reset(selRate);
  }, [selRate]);

  const dataUpdate = (param) => {
    setValue(`${param}.isUpdated`, true);
  };

  const baseChargeComponent = (service, index) => (
    <Col md={6} key={service.id}>
      <label className="form-label theme-label">
        {service.serviceType}{" "}
        {!!service.unitTypeText && service.unitTypeText.length > 0
          ? `(${service.unitTypeText})`
          : ""}
      </label>
      <input
        className="form-control"
        name={`baseChg.${index}.serviceUnitPrice`}
        {...register(`baseChg.${index}.serviceUnitPrice`, {
          required: {
            value: true,
            message: REQUIRED_ERR_MSG,
          },
          pattern: {
            value: NUMBER_NINE_DECIMAL,
            message: "Plesae Check For Format: xxxxxxxxx.xx",
          },
          onChange: () => dataUpdate(`baseChg.${index}`),
        })}
      />
      {!!errors?.baseChg && errors?.baseChg[index]?.serviceUnitPrice && (
        <div>
          <span className="text-danger fw-bold font-12">
            &#9888; {errors?.baseChg[index]?.serviceUnitPrice?.message}
          </span>
        </div>
      )}
    </Col>
  );
  const extServiceComponent = (service, index) => (
    <Row className="mb-2" key={service.id}>
      <Col md={1}>
        <div>{index + 1}</div>
      </Col>
      <Col md={5}>
        <input
          htmlFor=""
          className="form-control"
          readOnly
          value={service.serviceType}
        />
      </Col>
      <Col md={5}>
        <input
          type="number"
          className="form-control"
          name={`extService.${index}.${
            [CH_SRVC_TYPE.EXTRAMANPOWER].includes(service.serviceId)
              ? "serviceUnitPrice"
              : "serviceUnitPrice"
          }`}
          {...register(`extService.${index}.serviceUnitPrice`, {
            required: {
              value: true,
              message: REQUIRED_ERR_MSG,
            },
            pattern: {
              value: NUMBER_NINE_DECIMAL,
              message: "Plesae Check For Format: xxxxxxxxx.xx",
            },
            onChange: () => dataUpdate(`extService.${index}`),
          })}
          onWheel={(e) => numberInputOnWheelPreventChange(e)}
        />
        {!!errors?.extService &&
          errors?.extService[index]?.serviceUnitPrice && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888; {errors?.extService[index]?.serviceUnitPrice?.message}
              </span>
            </div>
          )}
      </Col>
      <Col md={1}></Col>
    </Row>
  );

  const piecesComponent = (service, index) => (
    <>
      <Row className="mt-2">
        <Col md={1}>
          <div>{index + 1}</div>
        </Col>
        <Col md={5}>
          <Row>
            <Col className="text-center pe-0">
              <label className="form-label theme-label me-2">
                {service.unitTypeText}
              </label>
            </Col>
          </Row>
        </Col>
        <Col md={5}>
          <input
            className="form-control"
            name={`pieces.${index}.serviceUnitPrice`}
            {...register(`pieces.${index}.serviceUnitPrice`, {
              required: {
                value: true,
                message: REQUIRED_ERR_MSG,
              },
              pattern: {
                value: NUMBER_NINE_DECIMAL,
                message: "Plesae Check For Format: xxxxxxxxx.xx",
              },
              onChange: () => dataUpdate(`pieces.${index}`),
            })}
          />
          {!!errors?.pieces && errors?.pieces[index]?.serviceUnitPrice && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888; {errors?.pieces[index]?.serviceUnitPrice?.message}
              </span>
            </div>
          )}
        </Col>
      </Row>
    </>
  );

  const handleOnRemove = (index, item, rmvCode) => {
    let copyDelSrvc = !!getValues("delSrvc") ? getValues("delSrvc") : [];
    item.isDeleted = true;
    copyDelSrvc.push(item);
    setValue("delSrvc", copyDelSrvc);

    switch (rmvCode) {
      case "VT":
        vtRemove(index);
        break;
      case "OC":
        ocRemove(index);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Modal
        show={modalConfig?.show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5 className="modal-title section-title">{modalConfig?.title}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          {error.value && (
            <Alert
              key="danger"
              variant="danger"
              onClose={() =>
                setError({
                  value: false,
                  message: "",
                })
              }
              dismissible
            >
              {error.message}
            </Alert>
          )}
          <Container>
            <Row>
              <Col md={6}>
                <label className="form-label theme-label">
                  Customer:
                  <span className="text-danger">&#9733;</span>
                </label>
                <Controller
                  name="custId"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "This field is required!!",
                    },
                    min: { value: 1, message: "This field is required!!" },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <Select
                      placeholder="Select Customer"
                      isSearchable={true}
                      isClearable={true}
                      className="form-control p-0"
                      options={custList}
                      value={
                        !!value
                          ? custList?.find((opt) => opt.value === value)
                          : value
                      }
                      onChange={(opt) => onChange(!!opt ? opt.value : 0)}
                      isOptionDisabled={(option) => option.disabled === true}
                      isDisabled={selRate?.custId > 0}
                    />
                  )}
                />
                {errors?.custId && (
                  <div>
                    <span className="text-danger fw-bold font-12">
                      &#9888; This field is mandatory
                    </span>
                  </div>
                )}
              </Col>

              {baseChg.map((service, index) =>
                baseChargeComponent(service, index)
              )}
            </Row>
            {/* <Row className="fw-bold mt-4 theme-violet-txt border-bottom">
              <h5>NORMAL UNIT PRICES</h5>
            </Row> */}
            {/* <Row>
              {baseChg.map((service, index) =>
                service.serviceId === CH_SRVC_TYPE.TAILGATE
                  ? tailgateComponent(service, index)
                  : baseChargeComponent(service, index)
              )}
            </Row> */}
            {/* <Row className="fw-bold mt-4 theme-violet-txt border-bottom">
              <h5>VEHICLE TYPE</h5>
            </Row> */}
            <Row className="border-bottom my-2 banner0 text-dark">
              <Col md={1}>
                <label className="form-label mb-0 theme-label ">Sl.No</label>
              </Col>
              <Col md={5} className="text-center">
                <label className="form-label theme-label mb-0 ">
                  Vehicle Type
                </label>
              </Col>
              <Col md={5} className="text-center">
                <label className="form-label theme-label mb-0">Price</label>
              </Col>
              <Col md={1} className="text-center">
                <label
                  className="form-label theme-label cursor-pointer"
                  onClick={() =>
                    vtAppend({
                      ...initSrvcObj,
                      serviceId: CH_SRVC_TYPE.VHCLTYPE,
                    })
                  }
                >
                  {GetSvgIcon("PlusCircle")}
                </label>
              </Col>
            </Row>

            {vhclType.map((service, index) => (
              <Row className="mb-1" key={service.id}>
                <Col md={1}>
                  <div>{index + 1}</div>
                </Col>
                <Col md={5}>
                  <Controller
                    name={`vhclType.${index}.rateRefId`}
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: REQUIRED_ERR_MSG,
                      },
                      min: {
                        value: 1,
                        message: "This field is required!!",
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        placeholder="Select Vehicle"
                        isSearchable={true}
                        isClearable={true}
                        className="form-control p-0"
                        options={vhclTypeOpt}
                        value={
                          !!value
                            ? vhclTypeOpt?.find((opt) => opt.value === value)
                            : value
                        }
                        onChange={(opt) => {
                          onChange(!!opt ? opt.value : 0);
                          dataUpdate(`vhclType.${index}`);
                        }}
                      />
                    )}
                  />
                  {!!errors?.vhclType && errors?.vhclType[index]?.rateRefId && (
                    <div>
                      <span className="text-danger fw-bold font-12">
                        &#9888; {errors?.vhclType[index]?.rateRefId?.message}
                      </span>
                    </div>
                  )}
                </Col>
                <Col md={5}>
                  <input
                    type="number"
                    className="form-control"
                    name={`vhclType.${index}.serviceUnitPrice`}
                    {...register(`vhclType.${index}.serviceUnitPrice`, {
                      required: {
                        value: true,
                        message: REQUIRED_ERR_MSG,
                      },
                      pattern: {
                        value: NUMBER_NINE_DECIMAL,
                        message: "Plesae Check For Format: xxxxxxxxx.xx",
                      },
                      min: {
                        value: 1,
                        message: REQUIRED_ERR_MSG,
                      },
                      onChange: () => dataUpdate(`vhclType.${index}`),
                    })}
                    onWheel={(e) => numberInputOnWheelPreventChange(e)}
                  />
                  {!!errors?.vhclType &&
                    errors?.vhclType[index]?.serviceUnitPrice && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888;{" "}
                          {errors?.vhclType[index]?.serviceUnitPrice?.message}
                        </span>
                      </div>
                    )}
                </Col>
                <Col md={1} className="text-center">
                  <label
                    className="form-label theme-label cursor-pointer"
                    onClick={() => handleOnRemove(index, service, "VT")}
                  >
                    {GetSvgIcon("DashCircleFill")}
                  </label>
                </Col>
              </Row>
            ))}
            {/* <Row className="fw-bold mt-4 theme-violet-txt border-bottom">
              <h5>CHOOSE OTHER SERVICES</h5>
            </Row> */}
            <Row className="border-bottom my-2 banner0 text-dark">
              <Col md={1}>
                <label className="form-label theme-label">Sl.No</label>
              </Col>
              <Col md={5} className="text-center">
                <label className="form-label theme-label ">Service Name</label>
              </Col>
              <Col md={5} className="text-center">
                <label className="form-label theme-label">Price</label>
              </Col>
              <Col md={1} className="text-center">
                <label
                  className="form-label theme-label cursor-pointer"
                  onClick={() =>
                    ocAppend({
                      ...initSrvcObj,
                      serviceId: CH_SRVC_TYPE.OTHERCHRG,
                    })
                  }
                >
                  {GetSvgIcon("PlusCircle")}
                </label>
              </Col>
            </Row>
            {extService.map((service, index) =>
              extServiceComponent(service, index)
            )}
            {otherCharges.map((service, index) => (
              <Row className="mb-1" key={service.id}>
                <Col md={1}>
                  <div>{extService.length + index + 1}</div>
                </Col>
                <Col md={5}>
                  <input
                    type="text"
                    className="form-control"
                    name={`otherCharges.${index}.rateRefName`}
                    {...register(`otherCharges.${index}.rateRefName`, {
                      required: {
                        value: true,
                        message: REQUIRED_ERR_MSG,
                      },
                      pattern: {
                        value: NAME_REGEX,
                        message: PTRN_ERR_MSG,
                      },
                      onChange: () => dataUpdate(`otherCharges.${index}`),
                    })}
                  />
                  {!!errors?.otherCharges &&
                    errors?.otherCharges[index]?.rateRefName && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888;{" "}
                          {errors?.otherCharges[index]?.rateRefName?.message}
                        </span>
                      </div>
                    )}
                </Col>
                <Col md={5}>
                  <input
                    className="form-control"
                    name={`otherCharges.${index}.serviceUnitPrice`}
                    {...register(`otherCharges.${index}.serviceUnitPrice`, {
                      required: {
                        value: true,
                        message: REQUIRED_ERR_MSG,
                      },
                      pattern: {
                        value: NUMBER_NINE_DECIMAL,
                        message: "Plesae Check For Format: xxxxxxxxx.xx",
                      },
                      min: {
                        value: 1,
                        message: REQUIRED_ERR_MSG,
                      },
                      onChange: () => dataUpdate(`otherCharges.${index}`),
                    })}
                  />
                  {!!errors?.otherCharges &&
                    errors?.otherCharges[index]?.serviceUnitPrice && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888;{" "}
                          {
                            errors?.otherCharges[index]?.serviceUnitPrice
                              ?.message
                          }
                        </span>
                      </div>
                    )}
                </Col>
                <Col md={1} className="text-center">
                  <label
                    className="form-label theme-label cursor-pointer"
                    onClick={() => handleOnRemove(index, service, "OC")}
                  >
                    {GetSvgIcon("DashCircleFill")}
                  </label>
                </Col>
              </Row>
            ))}
            {/* <Row className="fw-bold mt-4 theme-violet-txt border-bottom">
              <h5>PIECES</h5>
            </Row> */}
            <Row className="border-bottom my-2 banner0 text-dark ">
              <Col md={1}>
                <label className="form-label theme-label">Sl.No</label>
              </Col>
              <Col md={5} className="text-center">
                <label className="form-label theme-label ">Unit</label>
              </Col>
              <Col md={5} className="text-center">
                <label className="form-label theme-label">Unit Price</label>
              </Col>
            </Row>
            {pieces.map((p, i) => piecesComponent(p, i))}
          </Container>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center" }}>
          <Button
            variant="primary"
            className="theme-violet"
            disabled={+watchRateId > 0 && !isDirty}
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CharteredRateAddEdit;
